export default __webpack_public_path__ + "static/media/page-not-found-light.3cf0cb9b.svg";